export const orderDetailsPanelStyles = {
  header: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
  },
  body: {
    padding: 0,
  },
}
